import * as React from 'react';
import { ExperienceIcon, RegionIcon, SkillsIcon } from '../Icons';
import { AboutRealtorMobileSection } from '../AboutRealtorMobileSection';

interface IAdditionalInfoMobileProps {
  experience?: string;
  skills?: string[];
  regionsNames?: string[];
}

export const AdditionalInfoMobile: React.FC<React.PropsWithChildren<IAdditionalInfoMobileProps>> = props => {
  const { experience, skills, regionsNames } = props;

  return (
    <>
      {!!experience && (
        <AboutRealtorMobileSection pictureElement={<ExperienceIcon />} title="Опыт работы" text={experience} />
      )}
      {!!(skills && skills.length) && (
        <AboutRealtorMobileSection pictureElement={<SkillsIcon />} title="Специализация" text={skills.join('. ')} />
      )}
      {!!(regionsNames && regionsNames.length) && (
        <AboutRealtorMobileSection
          pictureElement={<RegionIcon />}
          title="Регион работы"
          text={regionsNames.join(', ')}
        />
      )}
    </>
  );
};
